module.exports = __webpack_public_path__ + "static/media/checkout-success.05f031bd.jpg";